module.exports = __webpack_public_path__ + "img/blood.0c545459.jpg";